import { render, staticRenderFns } from "./my-main.vue?vue&type=template&id=86ff944e&scoped=true"
import script from "./my-main.vue?vue&type=script&lang=js"
export * from "./my-main.vue?vue&type=script&lang=js"
import style0 from "./my-main.vue?vue&type=style&index=0&id=86ff944e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ff944e",
  null
  
)

export default component.exports